module.exports = __webpack_public_path__ + "static/img/home.a9d13f6b.jpg";